import React, { Component } from 'react';
import './estimate.scss';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as budgetActions from '../../actions/budgetActions';
import * as mandatoriesActions from '../../actions/mandatoriesActions';
import * as lineItemActions from '../../actions/lineItemActions';
import PropTypes from 'prop-types';
import ReactToPrint from "react-to-print";
import EstimateContent from './EstimateContent';
import * as Scroll from 'react-scroll';
import * as EmailJs from 'emailjs-com';

class EstimatePage extends Component {
	constructor(props, context) {
		super(props, context);
		Scroll.animateScroll.scrollToTop();
		this.resetHandler = this.resetHandler.bind(this);
		if(this.props.budget === null) {
			this.props.actions.loadBudgetContainers();
		}
		this.handleEmailEstimate = this.handleEmailEstimate.bind(this);
	}

	initBudgetLineItems() {
			if(this.props.budget !== null)
				this.loadLineItems(this.props.lineItems, this.props.budget.lines);
	}

	componentDidUpdate(prevProps, prevState) {
		if(this.props.budget !== prevProps.budget)
			this.initBudgetLineItems();
	}

	loadLineItems(itemRepo, reqItems) {
		reqItems.forEach(line => {
			var k = 'li' + line.id;
			if(itemRepo[k] === undefined)
				this.props.lineItemActions.loadBudgetLineItem(line.id)
		});
	}

	/**
	 * @param line           Item Description in internal summary email.
	 * @param line2          Unit cost in internal summary.
	 * @param line3          Price in internal summary.
	 * @param genConCost		 The general condition cost of the item.
	 * @param line4          Item Description in client summary email.
	 * @param line5          Selection in client summary email.
	 */
	appendLine(obj, line="", line2="", line3="", line4="", line5="") {
		const cash =  new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });
		obj.cost += line3;

		// Number.parseFloat(line2).toFixed(2)
		// Number.parseFloat(line3).toFixed(2)

		obj.summary += '<tr><td width="70%" align="left" class="ruler">'
			+ line + '</td><td align="right">';
		obj.summary	+= cash.format(Number.parseFloat(line2).toFixed(2)) + '</td><td align="right">'
			+ cash.format(Number.parseFloat(line3).toFixed(2)) + '</td></tr>';
		obj.summary += "\n";

		if (line5 <= 0) {
			obj.clientSummary += '<tr><td width="70%" align="left" class="ruler">'
				+ line4 + '</td><td align="right">'
				+ "None" + '</td></tr>';
			obj.clientSummary += "\n";
		} else if (line5 > 0) {
			obj.clientSummary += '<tr><td width="70%" align="left" class="ruler">'
				+ line4 + '</td><td align="right">'
				+ "Yes" + '</td></tr>';
			obj.clientSummary += "\n";
		} else {
			obj.clientSummary += '<tr><td width="70%" align="left" class="ruler">'
				+ line4 + '</td><td align="right">'
				+ line5 + '</td></tr>';
			obj.clientSummary += "\n";
		}

	}

	handleEmailEstimate(event) {
		let date = new Date().toLocaleDateString();
		const cash =  new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });
		var internalMandatories = Object.assign({}, this.props.mandatories, {summary: '<table cellpadding="0" cellspacing="0" align="center" bgcolor="#ffffff" border="0" width="100%" style="color:#000000; font-size: 14px; line-height: 100%; font-family: Arial, sans-serif; padding: 0 0 10px 0;"><tbody><tr><td align="center"><table cellpadding="0" cellspacing="30" align="center"  border="0" width="600" class="wrapper" style="width: 600px;">',
		clientSummary: '<table cellpadding="0" cellspacing="0" align="center" bgcolor="#ffffff" border="0" width="100%" style="color:#000000; font-size: 14px; line-height: 100%; font-family: Arial, sans-serif; padding: 0 0 10px 0;"><tbody><tr><td align="center"><table cellpadding="0" cellspacing="30" align="center"  border="0" width="600" class="wrapper" style="width: 600px;">', title: this.props.budget.title, date: date, costSqFt: '', cost: 0, costFormatted: ''});

		const {estimates} = this.props;
		const itemRepository = this.props.lineItems;
		internalMandatories.projectSqFt = this.props.mandatories.projectSqFt === "" ? Number(0) : this.props.mandatories.projectSqFt;
		internalMandatories.associates = this.props.mandatories.associates === "" ? Number(0) : this.props.mandatories.associates;

		// if the budget is #255 then you loop through
		// this.props.budgets on each iteration to determine
		// if the item is in design or building
		// new running total: let buildCost = 0;
		// new running total let DesignCost = 0;
		let buildCost = 0;
		let buildCostGenCon = 0;
		let buildCostFurnishInstall = 0;
		let buildCostFinishLevelCost = 0;

		let furnishCost = 0;
		let furnishCostGenCon = 0;
		let furnishCostFurnishInstall = 0;
		// getting a total before building the email summary so we can calculate
		// the percentage of total on the internal email summaries
		let costForPercent = 0;
		let costForPercentGenCon = 0;
		let furnishDesignCost = 0;
		let furnishInstallCost = 0;
		let finishLevelCost = 0;

		// healthcare general conditions costs add to a map of key value pairs
		let healthcareGenCost = new Map();

		if( this.props.budget.lines.length > 0 ) {
			for( let boo in this.props.budget.lines) {
				let index = "li" + this.props.budget.lines[boo].id;

				if(estimates[index] !== undefined) {
					for(let key in itemRepository[index].items){
						if(estimates[index][key] !== undefined) {
							key = Number(key);
							let item = itemRepository[index].items[key];
							if(item.item_type === "fieldGrid") {
								if(itemRepository[index].items[key+1] !== undefined &&
									itemRepository[index].items[key+1].item_type === "slider") {
										continue;
								} else {
									item.grid.forEach((val, wha) => {
										var tmp = estimates[index][key].selectedValues[wha] === undefined ? Number(0) : Number(estimates[index][key].selectedValues[wha]);
										if (this.props.budget.id === 225) {

											for (let index = 0; index < this.props.budgets.length; index++) {
												var element = this.props.budgets[index];

												if (element.title == "Build") {
													var buildCalculatorBudget = element;
												}
											}

											for(var buildLn in buildCalculatorBudget.lines) {
												let buildID = "li" + buildCalculatorBudget.lines[buildLn].id;
												if (index === buildID) {
													if (item.apply_general_conditions == true) {
														switch(val.cost_basis) {
															case 'assoc' :
																buildCostGenCon += Number(val.base_cost) * tmp * internalMandatories.associates;
															break;
															case 'sqft' :
																buildCostGenCon += Number(val.base_cost) * tmp * internalMandatories.projectSqFt;
															break;
															case 'flat' :
																buildCostGenCon += Number(val.base_cost) * tmp;
															break;
															default :
																buildCostGenCon += Number(val.base_cost) * tmp;
														}
													}
													if (item.apply_furnish_install == true) {
														switch(val.cost_basis) {
															case 'assoc' :
																buildCostFurnishInstall += Number(val.base_cost) * tmp * internalMandatories.associates;
															break;
															case 'sqft' :
																buildCostFurnishInstall += Number(val.base_cost) * tmp * internalMandatories.projectSqFt;
															break;
															case 'flat' :
																buildCostFurnishInstall += Number(val.base_cost) * tmp;
															break;
															default :
																buildCostFurnishInstall += Number(val.base_cost) * tmp;
														}
													}
													switch(val.cost_basis) {
														case 'assoc' :
															buildCost += Number(val.base_cost) * tmp * internalMandatories.associates;
														break;
														case 'sqft' :
															buildCost += Number(val.base_cost) * tmp * internalMandatories.projectSqFt;
														break;
														case 'flat' :
															buildCost += Number(val.base_cost) * tmp;
														break;
														default :
															buildCost += Number(val.base_cost) * tmp;
													}
												}
											}

											for (let index = 0; index < this.props.budgets.length; index++) {
												var element = this.props.budgets[index];

												if (element.title == "Furnish") {
													var furnishCalculatorBudget = element;
												}
											}

											for(var furnishLn in furnishCalculatorBudget.lines) {
												let furnishID = "li" + furnishCalculatorBudget.lines[furnishLn].id;
												if (index == furnishID) {
													if (item.apply_general_conditions == true) {
														switch(val.cost_basis) {
															case 'assoc' :
																furnishCostGenCon += Number(val.base_cost) * tmp * internalMandatories.associates;
															break;
															case 'sqft' :
																furnishCostGenCon += Number(val.base_cost) * tmp * internalMandatories.projectSqFt;
															break;
															case 'flat' :
																furnishCostGenCon += Number(val.base_cost) * tmp;
															break;
															default :
																furnishCostGenCon += Number(val.base_cost) * tmp;
														}
													}
													if (item.apply_furnish_install == true) {
														switch(val.cost_basis) {
															case 'assoc' :
																furnishCostFurnishInstall += Number(val.base_cost) * tmp * internalMandatories.associates;
															break;
															case 'sqft' :
																furnishCostFurnishInstall += Number(val.base_cost) * tmp * internalMandatories.projectSqFt;
															break;
															case 'flat' :
																furnishCostFurnishInstall += Number(val.base_cost) * tmp;
															break;
															default :
																furnishCostFurnishInstall += Number(val.base_cost) * tmp;
														}
													}
													switch(val.cost_basis) {
														case 'assoc' :
															furnishCost += Number(val.base_cost) * tmp * internalMandatories.associates;
														break;
														case 'sqft' :
															furnishCost += Number(val.base_cost) * tmp * internalMandatories.projectSqFt;
														break;
														case 'flat' :
															furnishCost += Number(val.base_cost) * tmp;
														break;
														default :
															furnishCost += Number(val.base_cost) * tmp;
													}
												}
											}
										}
										if (item.apply_general_conditions == true) {
											switch(val.cost_basis) {
												case 'assoc' :
													costForPercentGenCon += Number(val.base_cost) * tmp * internalMandatories.associates;
												break;
												case 'sqft' :
													costForPercentGenCon += Number(val.base_cost) * tmp * internalMandatories.projectSqFt;
												break;
												case 'flat' :
													costForPercentGenCon += Number(val.base_cost) * tmp;
												break;
												default :
													costForPercentGenCon += Number(val.base_cost) * tmp;
											}
										}
										if (item.apply_furnish_install == true) {
											switch(val.cost_basis) {
												case 'assoc' :
													furnishInstallCost += Number(val.base_cost) * tmp * internalMandatories.associates;
												break;
												case 'sqft' :
													furnishInstallCost += Number(val.base_cost) * tmp * internalMandatories.projectSqFt;
												break;
												case 'flat' :
													furnishInstallCost += Number(val.base_cost) * tmp;
												break;
												default :
													furnishInstallCost += Number(val.base_cost) * tmp;
											}
										}
										switch(val.cost_basis) {
											case 'assoc' :
												costForPercent += Number(val.base_cost) * tmp * internalMandatories.associates;
											break;
											case 'sqft' :
												costForPercent += Number(val.base_cost) * tmp * internalMandatories.projectSqFt;
											break;
											case 'flat' :
												costForPercent += Number(val.base_cost) * tmp;
											break;
											case 'healthcare' :
												healthcareGenCost.set(val.title, val.base_cost * tmp);
											break;
											default :
												costForPercent += Number(val.base_cost) * tmp;
										}
									});
								}
							}
							if(item.item_type === 'slider') {
								if(itemRepository[index].items[key-1] !== undefined &&
									itemRepository[index].items[key-1].item_type === "fieldGrid" &&
									estimates[index][key-1] !== undefined) {
										const sel = estimates[index][key].selectedSliderIndex === null ? 0 : estimates[index][key].selectedSliderIndex-1;
										const sliderText = itemRepository[index].items[key].slider.stops[sel];
										const gridItem = itemRepository[index].items[key-1];
										const gridEst = estimates[index][key-1];
										for(var gI in gridItem.grid) {
											if(gridEst.selectedValues[gI] !== undefined && Number(gridEst.selectedValues[gI]) > 0) {

												if (this.props.budget.id == 225) {

													for (let index = 0; index < this.props.budgets.length; index++) {
														var element = this.props.budgets[index];
		
														if (element.title == "Build") {
															var buildCalculatorBudget = element;
														}
													}

													for(var buildLn in buildCalculatorBudget.lines) {
														let buildID = "li" + buildCalculatorBudget.lines[buildLn].id;
														if (index == buildID) {
															if (item.apply_general_conditions == true) {
																buildCostGenCon += Number(gridItem.grid[gI].base_cost)*Number(sliderText.stop_multiplier)*Number(gridEst.selectedValues[gI]);
															}
															if (item.apply_furnish_install == true) {
																buildCostFurnishInstall += Number(gridItem.grid[gI].base_cost)*Number(sliderText.stop_multiplier)*Number(gridEst.selectedValues[gI]);
															}
															buildCost += Number(gridItem.grid[gI].base_cost)*Number(sliderText.stop_multiplier)*Number(gridEst.selectedValues[gI]);
														}
													}

													for (let index = 0; index < this.props.budgets.length; index++) {
														var element = this.props.budgets[index];
		
														if (element.title == "Furnish") {
															var furnishCalculatorBudget = element;
														}
													}

													for(var furnishLn in furnishCalculatorBudget.lines) {
														let furnishID = "li" + furnishCalculatorBudget.lines[furnishLn].id;
														if (index == furnishID) {
															if (item.apply_general_conditions == true) {
																furnishCostGenCon += Number(gridItem.grid[gI].base_cost)*Number(sliderText.stop_multiplier)*Number(gridEst.selectedValues[gI]);
															}
															if (item.apply_furnish_install == true) {
																furnishCostFurnishInstall += Number(gridItem.grid[gI].base_cost)*Number(sliderText.stop_multiplier)*Number(gridEst.selectedValues[gI]);
															}
															furnishCost += Number(gridItem.grid[gI].base_cost)*Number(sliderText.stop_multiplier)*Number(gridEst.selectedValues[gI]);
														}
													}
												}
												if (item.apply_general_conditions == true) {
													costForPercentGenCon += Number(gridItem.grid[gI].base_cost)*Number(sliderText.stop_multiplier)*Number(gridEst.selectedValues[gI]);
												}
												if (item.apply_furnish_install == true) {
													furnishInstallCost += Number(gridItem.grid[gI].base_cost)*Number(sliderText.stop_multiplier)*Number(gridEst.selectedValues[gI]);
												}
												costForPercent += Number(gridItem.grid[gI].base_cost)*Number(sliderText.stop_multiplier)*Number(gridEst.selectedValues[gI]);
											}
										}
								} else {
									try{
										const sel = estimates[index][key].selectedSliderIndex === null ? 0 : estimates[index][key].selectedSliderIndex-1;
										if (this.props.budget.id == 225) {

											for (let index = 0; index < this.props.budgets.length; index++) {
												var element = this.props.budgets[index];

												if (element.title == "Build") {
													var buildCalculatorBudget = element;
												}
											}

											for(var buildLn in buildCalculatorBudget.lines) {
												let buildID = "li" + buildCalculatorBudget.lines[buildLn].id;
												if (index == buildID) {
													if (item.apply_general_conditions == true) {
														buildCostGenCon += Number(item.slider.stops[sel].stop_multiplier)*internalMandatories.projectSqFt;
													}
													// buildCost += Number(item.slider.stops[sel].stop_multiplier)*internalMandatories.projectSqFt;
													switch(item.item_title) {
														case 'Select Project Finish Level' :
															buildCostFinishLevelCost = Number(item.slider.stops[sel].stop_multiplier)*internalMandatories.projectSqFt;
															buildCost += Number(item.slider.stops[sel].stop_multiplier)*internalMandatories.projectSqFt;
														break;
														case 'Select Level of Finish for Existing Walls ' :
															buildCost += Number(item.slider.stops[sel].stop_multiplier)*buildCostFinishLevelCost;
															if (item.apply_general_conditions == true) {
																buildCostGenCon -= Number(item.slider.stops[sel].stop_multiplier)*internalMandatories.projectSqFt;
																buildCostGenCon += Number(item.slider.stops[sel].stop_multiplier)*finishLevelCost;
															}
														break;
														default :
															buildCost += Number(item.slider.stops[sel].stop_multiplier)*internalMandatories.projectSqFt;
													}
												}
											}

											for (let index = 0; index < this.props.budgets.length; index++) {
												var element = this.props.budgets[index];

												if (element.title == "Furnish") {
													var furnishCalculatorBudget = element;
												}
											}

											for(var furnishLn in furnishCalculatorBudget.lines) {
												let furnishID = "li" + furnishCalculatorBudget.lines[furnishLn].id;
												if (index == furnishID) {
													if (item.apply_general_conditions == true) {
														furnishCostGenCon += Number(item.slider.stops[sel].stop_multiplier)*internalMandatories.projectSqFt;
													}
													furnishCost += Number(item.slider.stops[sel].stop_multiplier)*internalMandatories.projectSqFt;
												}
											}
										}
										if (item.apply_general_conditions == true) {
											costForPercentGenCon += Number(item.slider.stops[sel].stop_multiplier)*internalMandatories.projectSqFt;
										}
										if (item.apply_furnish_install == true) {
											furnishInstallCost += Number(item.slider.stops[sel].stop_multiplier)*internalMandatories.projectSqFt;
										}
										switch(item.item_title) {
											case 'Select Project Finish Level' :
												finishLevelCost = Number(item.slider.stops[sel].stop_multiplier)*internalMandatories.projectSqFt;
												costForPercent += Number(item.slider.stops[sel].stop_multiplier)*internalMandatories.projectSqFt;
											break;
											case 'Select Level of Finish for Existing Walls ' :
												costForPercent += Number(item.slider.stops[sel].stop_multiplier)*finishLevelCost;
												if (item.apply_general_conditions == true) {
													costForPercentGenCon -= Number(item.slider.stops[sel].stop_multiplier)*internalMandatories.projectSqFt;
													costForPercentGenCon += Number(item.slider.stops[sel].stop_multiplier)*finishLevelCost;
												}
											break;
											default :
												costForPercent += Number(item.slider.stops[sel].stop_multiplier)*internalMandatories.projectSqFt;
										}
										// costForPercent += Number(item.slider.stops[sel].stop_multiplier)*internalMandatories.projectSqFt;
									} catch(e) {
										console.log(e);
									}
								}
							}
						}
					}
				}
			}
		}

		// add healthcare general conditions
	  for (const [k, v] of healthcareGenCost.entries()) {
	    let hcGenCost = costForPercent * (v/100);
	    healthcareGenCost.set(k, hcGenCost);
	  }
	  for (const [k, v] of healthcareGenCost.entries()) {
	    costForPercent += healthcareGenCost.get(k);
	  }

		// if (this.props.budget.id != 137) {
		// 	if (this.props.mandatories.projectSqFt > 2500) {
		// 		furnishDesignCost = this.props.mandatories.projectSqFt;
		// 	} else {
		// 		furnishDesignCost = 2500;
		// 	}
		// }
		// costForPercent += furnishDesignCost;
		// furnishCost += furnishDesignCost;


		// // get the furnish design cost at $1 per sqFt, 2500 min
		// let furnishDesignCost = 0;
		if (this.props.budget.id == 137 || this.props.budget.title.trim() == "Healthcare") {
			// do nothing becuase we don't have furnish
		}
		else {
			// add the furnish sq ft cost
			if (this.props.mandatories.projectSqFt > 2500) {
				furnishDesignCost = this.props.mandatories.projectSqFt;
			} else {
				furnishDesignCost = 2500;
			}
		}
		costForPercent += furnishDesignCost;
		furnishCost += furnishDesignCost;


		let xVar = (this.props.mandatories.projectSqFt * 5.75);

		if (costForPercentGenCon > 0) {
			costForPercent += (xVar + (costForPercentGenCon * .10)) / 2;
		}
		costForPercent += (furnishInstallCost * .05);

		if (buildCostGenCon > 0) {
			buildCost += (xVar + (buildCostGenCon * .10)) / 2;
		}

		furnishCost += (furnishCostFurnishInstall * .05);


		// lets start the loop here looking for answered budget items
		if( this.props.budget.lines.length > 0 ) {
			for( let boo in this.props.budget.lines) {
				let index = "li" + this.props.budget.lines[boo].id;
				if(estimates[index] !== undefined) {
					// now we found an element in the item repository with budget figures
					// lets dive and look at what actual item values are
					for(let key in itemRepository[index].items){
						if(estimates[index][key] !== undefined) {
							key = Number(key);
							let item = itemRepository[index].items[key];
							if(item.item_type === "fieldGrid") {

								// Heres the kicker... anytime we have a field grid
								// we check the following item to see if it's a slider
								// if we find a slider we stop parsing this grid item and
								// parse it with the slider.
								if(itemRepository[index].items[key+1] !== undefined &&
									itemRepository[index].items[key+1].item_type === "slider") {

										continue;
								} else {
									item.grid.forEach((val, wha) => {
										var tmp = estimates[index][key].selectedValues[wha] === undefined ? Number(0) : Number(estimates[index][key].selectedValues[wha]);
										switch(val.cost_basis) {
											case 'assoc' :
											this.appendLine(internalMandatories,
												item.item_title + " : " + val.title + " - Cost Basis: " + val.cost_basis
												+ " - Total % of budget: "
												+	Number.parseFloat(((Number(val.base_cost) * tmp * internalMandatories.associates / costForPercent) * 100)).toFixed(2) + "%",
												Number(val.base_cost) * tmp,
												Number(val.base_cost) * tmp * internalMandatories.associates,
												item.item_title + ": " + val.title,
												Number(val.base_cost) * tmp
												);
											break;
											case 'sqft' :
											this.appendLine(internalMandatories,
												item.item_title + " : " + val.title + " - Cost Basis: " + val.cost_basis
												+ " - Total % of budget: "
												+	Number.parseFloat(((Number(val.base_cost) * tmp * internalMandatories.projectSqFt / costForPercent) * 100)).toFixed(2) + "%",
												Number(val.base_cost) * tmp,
												Number(val.base_cost) * tmp * internalMandatories.projectSqFt,
												item.item_title + ": " + val.title,
												Number(val.base_cost) * tmp
											);
											break;
											case 'flat' :
											this.appendLine(internalMandatories,
												item.item_title + " : " + val.title + " - Cost Basis: " + val.cost_basis
												+ " - Total % of budget: "
												+	Number.parseFloat(((Number(val.base_cost) * tmp / costForPercent) * 100)).toFixed(2) + "%",
												Number(val.base_cost) * tmp,
												Number(val.base_cost) * tmp,
												item.item_title + ": " + val.title,
												Number(val.base_cost) * tmp
											);
											break;
											case 'healthcare' :
											this.appendLine(internalMandatories,
												item.item_title + " : " + val.title,
												Number(val.base_cost) * tmp,
												healthcareGenCost.get(val.title),
												item.item_title + " : " + val.title,
												healthcareGenCost.get(val.title)
											);
											break;
											default :
											this.appendLine(internalMandatories,
												item.item_title + " : " + val.title + " - Cost Basis: " + val.cost_basis
												+ " - Total % of budget: "
												+	Number.parseFloat(((Number(val.base_cost) * tmp / costForPercent) * 100)).toFixed(2) + "%",
												Number(val.base_cost) * tmp,
												Number(val.base_cost) * tmp,
												item.item_title + " : " + val.title,
												Number(val.base_cost) * tmp
											);
										}

									});
								}
							}

							if(item.item_type === 'slider') {
								// This side of the if/else handles sliders when they relate to
								// grids
								if(itemRepository[index].items[key-1] !== undefined &&
									itemRepository[index].items[key-1].item_type === "fieldGrid" &&
									estimates[index][key-1] !== undefined) {
										// When working with slider remember that the slider reports it's value as on the
										// first step as "1", because everything else operates on a zero index we subtract
										// '1' from the value of the slider.
										const sel = estimates[index][key].selectedSliderIndex === null ? 0 : estimates[index][key].selectedSliderIndex-1;
										const sliderText = itemRepository[index].items[key].slider.stops[sel];
										const gridItem = itemRepository[index].items[key-1];
										const gridEst = estimates[index][key-1];
										for(var gI in gridItem.grid) {
											if(gridEst.selectedValues[gI] !== undefined && Number(gridEst.selectedValues[gI]) > 0) {
												this.appendLine(internalMandatories,
												gridItem.item_title
												+ " - Quantity:" + gridEst.selectedValues[gI]
												+ " - Total % of budget: "
												+	Number.parseFloat(((Number(gridItem.grid[gI].base_cost)*Number(sliderText.stop_multiplier)
													*Number(gridEst.selectedValues[gI])) / costForPercent) * 100).toFixed(2) + "%"
												+ gridItem.grid[gI].title + " - "
												+ sliderText.title + item.slider.stops[sel].content,
												Number(gridItem.grid[gI].base_cost)*Number(sliderText.stop_multiplier),
												Number(gridItem.grid[gI].base_cost)*Number(sliderText.stop_multiplier)
													*Number(gridEst.selectedValues[gI]),
												gridItem.item_title + " - Quantity:" + gridEst.selectedValues[gI],
												sliderText.title)
											}
										}
								} else {
									// This is a normal slider
									// start by getting the selection from our estimate
									try{
									const sel = estimates[index][key].selectedSliderIndex === null ? 0 : estimates[index][key].selectedSliderIndex-1;

									switch(item.item_title) {
										case 'Select Project Finish Level' :
											finishLevelCost = Number(item.slider.stops[sel].stop_multiplier)*internalMandatories.projectSqFt;
											this.appendLine(internalMandatories,
												item.item_title + ": " + item.slider.stops[sel].title
												+ " - Total % of budget: "
												+	Number.parseFloat(((Number(item.slider.stops[sel].stop_multiplier)*internalMandatories.projectSqFt / costForPercent) * 100)).toFixed(2) + "%"
												+ item.slider.stops[sel].content,
												item.slider.stops[sel].stop_multiplier,
												Number(item.slider.stops[sel].stop_multiplier)*internalMandatories.projectSqFt,
											  item.item_title + ": " + item.slider.stops[sel].content,
												item.slider.stops[sel].title);
										break;
										case 'Select Level of Finish for Existing Walls ' :
											this.appendLine(internalMandatories,
												item.item_title + ": " + item.slider.stops[sel].title
												+ " - Total % of budget: "
												+	Number.parseFloat(((Number(item.slider.stops[sel].stop_multiplier)*finishLevelCost / costForPercent) * 100)).toFixed(2) + "%"
												+ item.slider.stops[sel].content,
												item.slider.stops[sel].stop_multiplier,
												(Number(item.slider.stops[sel].stop_multiplier)*finishLevelCost),
											  item.item_title + ": " + item.slider.stops[sel].content,
												item.slider.stops[sel].title);
										break;
										default :
											this.appendLine(internalMandatories,
												item.item_title + ": " + item.slider.stops[sel].title
												+ " - Total % of budget: "
												+	Number.parseFloat(((Number(item.slider.stops[sel].stop_multiplier)*internalMandatories.projectSqFt / costForPercent) * 100)).toFixed(2) + "%"
												+ item.slider.stops[sel].content,
												item.slider.stops[sel].stop_multiplier,
												Number(item.slider.stops[sel].stop_multiplier)*internalMandatories.projectSqFt,
											  item.item_title + ": " + item.slider.stops[sel].content,
												item.slider.stops[sel].title);
									}

									// this.appendLine(internalMandatories,
									// 	item.item_title + ": " + item.slider.stops[sel].title
									// 	+ " - Total % of budget: "
									// 	+	Number.parseFloat(((Number(item.slider.stops[sel].stop_multiplier)*internalMandatories.projectSqFt / costForPercent) * 100)).toFixed(2) + "%"
									// 	+ item.slider.stops[sel].content,
									// 	item.slider.stops[sel].stop_multiplier,
									// 	Number(item.slider.stops[sel].stop_multiplier)*internalMandatories.projectSqFt,
									//   item.item_title + ": " + item.slider.stops[sel].content,
									// 	item.slider.stops[sel].title);
									} catch(e) {
										console.log(e);
									}
								}
							}
						}
					}
				}
			}
		}
		// Do not need to do the healthcare loop and add. is already done elsewhere
		// for (const [k, v] of healthcareGenCost.entries()) {
		// 	internalMandatories.cost += healthcareGenCost.get(k);
	  // }

		// get the furnish design cost at $1 per sqFt, 2500 min
		// let furnishDesignCost = 0;
		if (this.props.budget.id == 137 || this.props.budget.title.trim() == "Healthcare") {
			// do nothing becuase we don't have furnish
		}
		else {
			// add the furnish sq ft cost
			if (this.props.mandatories.projectSqFt > 2500) {
				furnishDesignCost = this.props.mandatories.projectSqFt;
			} else {
				furnishDesignCost = 2500;
			}
		}
		internalMandatories.cost += furnishDesignCost;

		internalMandatories.cost += (furnishInstallCost * .05);
		let generalConditions = ((xVar + (costForPercentGenCon * .10)) / 2);
		if (costForPercentGenCon > 0) {
			internalMandatories.cost += generalConditions;
		}

		if (this.props.budget.id != 224) {
			internalMandatories.summary += '<tr><td width="70%" align="left" class="ruler">'
				+ 'General conditions Cost - Total % of budget: ' + Number.parseFloat(((generalConditions / costForPercent) * 100)).toFixed(2) + '%</td><td align="right"></td>';
			internalMandatories.summary	+= '<td align="right">' + cash.format(Number.parseFloat(generalConditions).toFixed(2)) + '</td></tr>';
			internalMandatories.summary += "\n";
		}

		internalMandatories.summary += '<tr><td width="70%" align="left" class="ruler">'
			+ 'Furnish Design Budget - Total % of budget: ' + Number.parseFloat(((furnishDesignCost / costForPercent) * 100)).toFixed(2) + '%</td><td align="right"></td>';
		internalMandatories.summary	+= '<td align="right">' + cash.format(Number.parseFloat(furnishDesignCost).toFixed(2)) + '</td></tr>';
		internalMandatories.summary += "\n";

		internalMandatories.summary += '<tr><td width="70%" align="left" class="ruler">'
			+ 'Install 5% of Sell - Total % of budget: ' + Number.parseFloat((((furnishInstallCost * .05) / costForPercent) * 100)).toFixed(2) + '%</td><td align="right"></td>';
		internalMandatories.summary	+= '<td align="right">' + cash.format(Number.parseFloat((furnishInstallCost * .05)).toFixed(2)) + '</td></tr>';
		internalMandatories.summary += "\n";

		internalMandatories.summary += '</table> </td></tr>	</tbody></table>';
		internalMandatories.clientSummary += '</table> </td></tr>	</tbody></table>';
		internalMandatories.cost = Math.round(internalMandatories.cost);

		if (this.props.budget.id == 225) {
			const internalMandatoriesSubtotals = {buildEstimate: "Build Estimate", furnishEstimate: "Furnish Estimate", buildCost: cash.format(Math.round(buildCost)), furnishCost: cash.format(Math.round(furnishCost))}
			Object.assign(internalMandatories, internalMandatoriesSubtotals);
		}
		const min = internalMandatories.cost * .95;
		const max = internalMandatories.cost * 1.05;
		internalMandatories.costFormatted = cash.format(Math.round(min)) + " - " + cash.format(Math.round(max));
		internalMandatories.costSqFt = cash.format(Math.round(min/internalMandatories.projectSqFt))
			+ " - " + cash.format(Math.round(max/internalMandatories.projectSqFt));

		EmailJs.send('mailgun', 'corpcalc', internalMandatories, 'user_CcX0bsDOhRGIPedSb4bGX' )
			.then(function(response) {
				var emailBtns = document.getElementsByClassName("email-btn");
				for (var i = 0; i < emailBtns.length; i++) {
					emailBtns[i].innerHTML = "Estimate Sent!";
				}
			}, function(error) {
				 console.log('FAILED...', error);
			});
		EmailJs.send('mailgun', 'usercalc', internalMandatories, 'user_CcX0bsDOhRGIPedSb4bGX' )
			.then(function(response) {
				//
			}, function(error) {
				 console.log('FAILED...', error);
			});
		event.preventDefault();
		return false;
	}


	resetHandler() {
		this.props.actions.resetCalculator();
		try{
			localStorage.clear();
			sessionStorage.clear();
		} catch(err) {

		}
		window.setTimeout(() => {window.location = '/calculator';}, 1000)
		return false;
	}

  render() {
    return (
      <div className="estimate-page">

					{this.props.budget !== null
					&& Object.keys(this.props.lineItems).length >= this.props.budget.lines.length
					&& <EstimateContent
						mandatories={this.props.mandatories}
						lines={this.props.lineItems}
						estimates={this.props.estimates}
						calculator={this.props.budget}
						budgets={this.props.budgets}
						ref={el => (this.componentRef = el)} />}

				<section className='estimate'>
					<div className='row'>
						<div className='col center'>
								<ReactToPrint
          				trigger={() => <a className="btn large btn-print">Print</a>}
          				content={() => this.componentRef} />

								<button type="button" className="btn large email-btn" onClick={this.handleEmailEstimate}>Email</button>
								<button type="button" className="btn done large" onClick={() => {this.context.router.history.goBack()}}>Edit</button>
								<br />
								<br />
								<a onClick={this.resetHandler}>New Estimate</a>
						</div>
					</div>
				</section>

      </div>

    );
  }
}

EstimatePage.propTypes = {
	match : PropTypes.object,
	budget: PropTypes.object
}

const mapDispatchToProps = (dispatch, ownProps) => {
	return {
		actions: bindActionCreators(budgetActions, dispatch),
		lineItemActions: bindActionCreators(lineItemActions, dispatch),
		mandatoriesActions: bindActionCreators(mandatoriesActions, dispatch)
	};
}

const mapStateToProps = (state, ownProps) => {

	const current = ownProps.match.params.id === undefined ? null : Number(ownProps.match.params.id)

	let theBudget = state.budgets.length < 1 ? null : state.budgets.find((obj) => {if(obj.id === current) return obj});

	return {
		budgets: state.budgets,
		budget: theBudget,
		lineItems: state.lineItems,
		mandatories: state.mandatories,
		estimates: state.estimates
	}
}

EstimatePage.contextTypes = {
	router: PropTypes.object
}

export default connect(mapStateToProps, mapDispatchToProps)(EstimatePage);



// WEBPACK FOOTER //
// ./src/components/estimate/EstimatePage.js